const PlayerStopIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M6 3H13V13H4V3ZM5 4V12H12V4H7Z" fill="currentColor"/>
        </svg>
    )
}

export default PlayerStopIcon;